import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import getQueryParam from 'get-query-param';
import creditcardPrecalculationForm from './creditcard-precalculation-form/creditcard-precalculation-form.vue';
import creditcardPrecalculationResults from './creditcard-precalculation-result/creditcard-precalculation-result.vue';
import { required } from 'vuelidate/lib/validators';
import { BACKEND_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../common/js/constants/constants';
const NOT_ELIGIBLE_FOR_CARDS = 'Egyáltalán nem jogosult';
export const APPLICATION_TYPE = {
	LANDING: 'landing',
	APPLICATION: 'appplication'
};
export default {
	data() {
		return {
			selectedCardId: null,
			vhkInited: false
		};
	},
	props: {
		cardId: {
			required
		},
		swImgPath: {
			required
		},
		folyoszamlaHitelLink: {
			required
		},
		hitelkartyaIgenylesLink: {
			required
		},
		hitelkartyakLink: {
			required
		},
		vhkProductId: {
			required: false
		},
		vhkQuestionId: {
			required: false
		},
		type: {
			required: false,
			default: APPLICATION_TYPE.APPLICATION
		}
	},
	components: {
		creditcardPrecalculationForm,
		creditcardPrecalculationResults
	},
	computed: {
		isLanding() {
			return this.type == APPLICATION_TYPE.LANDING;
		},
		...mapState('creditCardPreCalculation', [
			'loading',
			'technicalError',
			'preCalculated',
			'initData',
			'captcha',
			'calculationResult',
			'minimumWage',
			'captchaError',
			'calculationSessionId',
			'operatorToken',
			'oldSessionId'
		])
	},
	created() {
		this.getInitData();
		// ez azért így, mert a query erősebb, mint a prop
		this.selectedCardId = this.cardId;
		this.selectedCardId = getQueryParam('cardId', window.location.href) || this.selectedCardId;
		let operatorToken = getQueryParam('operatorToken', window.location.href);
		this.setOperatorToken(operatorToken);
		const event = new CustomEvent('call-request-ccp-set-payload', { detail: this.oldSessionId });
		window.dispatchEvent(event);
	},
	methods: {
		transformAndPreCalculate(data) {
			let result = {
				sessionId: this.initData.sessionId,
				cardId: this.selectedCardId,
				dateOfBirth: moment(data.birthDate, DISPLAY_DATE_FORMAT[this.$i18n.locale]).format(BACKEND_DATE_FORMAT),
				hasOTPBankAccount: data.hasAccount,
				netIncome: data.income,
				hasLoan: data.hasLoan == 'hasLoan',
				contribution: data.contribution == 'CONTRIBUTE_YES',
				regularMonthlyRepayment: data.monthlyFee,
				creditCardCreditAllocation: data.cardCreditLine,
				currentAccountCreditAllocation: data.loanAmount,
				ongoingSmallAmountLoan: data.payingLoan,
				khr: data.inKhr == 'inKhr',
				captchaToken: this.initData.captcha ? this.initData.captcha.captchaToken : '',
				captchaText: data.captchaText ? data.captchaText : ''
			};
			this.preCalculate(result).then((oldSessionId) => {
				const eventCcp = new CustomEvent('call-request-ccp-set-payload', { detail: oldSessionId });
				window.dispatchEvent(eventCcp);
				const eventCcpl = new CustomEvent('call-request-ccpl-set-payload', { detail: oldSessionId });
				window.dispatchEvent(eventCcpl);
			});
		},
		startCalculation(data) {
			let dataToPost = {
				cardId: data.cardId,
				sessionId: this.calculationSessionId,
				eligible: data.eligible
			};
			this.postStartCalculation(dataToPost).then(() => {
				if (this.operatorToken) {
					window.location.href =
						this.hitelkartyaIgenylesLink + '?sessionId=' + this.calculationSessionId + '&preCalculation=true&operatorToken=' + this.operatorToken;
				} else {
					window.location.href = this.hitelkartyaIgenylesLink + '?sessionId=' + this.calculationSessionId + '&preCalculation=true';
				}
			});
		},
		...mapActions('creditCardPreCalculation', ['preCalculate', 'getInitData', 'postStartCalculation', 'setOperatorToken', 'sendTa'])
	},
	watch: {
		cardId(val) {
			if (val) {
				this.selectedCardId = val;
			}
		},
		calculationResult(value) {
			if (value) {
				let availableCards = [];
				if (value.eligibleForSelectedCard) {
					availableCards.push(value.requestedCard.cardId);
				}
				if (value.availableCards && value.availableCards.length) {
					value.availableCards.forEach((item) => {
						if (availableCards.indexOf(item.cardId) === -1) {
							availableCards.push(item.cardId);
						}
					});
				}
				let creditcardPreCalcStatus = availableCards.join(',');
				creditcardPreCalcStatus = creditcardPreCalcStatus || NOT_ELIGIBLE_FOR_CARDS;
				this.$gtm.trackEvent({
					event: 'creditcardRequestPreCalcResult',
					creditcardPreCalcStatus
				});
			}
		}
	}
};
